"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfServiceClient = void 0;
const client_1 = require("../../abstracts/client");
const config_1 = require("../../shared/config");
class PdfServiceClient extends client_1.Client {
    constructor(parentEntity, debug = false) {
        super(parentEntity, debug);
        this.BASE_URLS = {
            'PROD': 'https://pdf-service-api.nebulr-core.com',
            'STAGE': 'https://pdf-service-api-stage.nebulr-core.com',
            'DEV': 'http://pdf-service-api:3000'
        };
        this.tenantId = parentEntity.id;
    }
    /**
     * Generate PDF file on the base of provided HTML file
     * @param args CreateArgsDto
     *
     * @returns CreateResponseDto
     */
    async createFromHtml(args) {
        const reqArgs = { ...args, tenantId: this.tenantId };
        const response = (await this.getHttpClient().post(`pdf/createFromHtml`, reqArgs, { headers: this.getHeaders(), baseURL: this._getBaseUrl() })).data;
        return response;
    }
    /**
     * Generate PDF file based on URL
     * @param args CreateArgsDto
     *
     * @returns CreateResponseDto
     */
    async createFromUrl(args) {
        const reqArgs = { ...args, tenantId: this.tenantId };
        const response = (await this.getHttpClient().post(`pdf/createFromHtml`, reqArgs, { headers: this.getHeaders(), baseURL: this._getBaseUrl() })).data;
        return response;
    }
    /**
    * Gets the base url by fetching current stage from Platform
    *
    * @returns
    */
    _getBaseUrl() {
        return config_1.ConfigHelper.getEnvVariable("NBLOCKS_PDF_SERVICE_API_URL") || this.BASE_URLS[this.getPlatformClient().stage];
    }
}
exports.PdfServiceClient = PdfServiceClient;
